import { Lager_Treyd_Users } from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

export type SignAloneUsersVariables = {
  company_id: number;
};

export type SignAloneUsers = {
  lager_treyd_users: Array<Pick<Lager_Treyd_Users, 'name' | 'user_id'>>;
};

export const getCompanySignAloneUsersQuery = gql`
  query getSignatoryUsers($company_id: bigint!) {
    lager_treyd_users(
      where: {
        _and: [
          { company_id: { _eq: $company_id } }
          { can_sign_alone: { _eq: true } }
        ]
      }
    ) {
      name
      user_id
    }
  }
` as TypedDocumentNode<SignAloneUsers, SignAloneUsersVariables>;
